import { useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'qreativs-theme';

const getInitial = () => {
  if (typeof window === 'undefined') return 'dark';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return 'dark'; // default to dark to match the brand aesthetic
};

const applyTheme = (theme) => {
  const root = document.documentElement;
  if (theme === 'light') {
    root.classList.add('light');
    root.classList.remove('dark');
  } else {
    root.classList.add('dark');
    root.classList.remove('light');
  }
};

// --- Shared module-level store so ALL components stay in sync ---
let currentTheme = getInitial();
let listeners = [];

if (typeof window !== 'undefined') {
  applyTheme(currentTheme);
}

const setThemeGlobal = (theme) => {
  currentTheme = theme;
  applyTheme(theme);
  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch (_) {
    /* ignore */
  }
  listeners.forEach((l) => l(theme));
};

export const useTheme = () => {
  const [theme, setLocal] = useState(currentTheme);

  useEffect(() => {
    const listener = (t) => setLocal(t);
    listeners.push(listener);
    // sync in case it changed before mount
    setLocal(currentTheme);
    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  }, []);

  const setTheme = useCallback((t) => setThemeGlobal(t), []);
  const toggle = useCallback(
    () => setThemeGlobal(currentTheme === 'dark' ? 'light' : 'dark'),
    []
  );

  return { theme, setTheme, toggle };
};

export default useTheme;
